const updates = [
  { date: '2026-07-30', title: '新增4K超清专区上线', desc: '首批200部精选视频支持4K分辨率播放' },
  { date: '2026-07-28', title: '移动端界面全新升级', desc: '优化触控体验，新增手势控制功能' },
  { date: '2026-07-25', title: '热门纪录大片专题上线', desc: '年度高分纪录佳作一次性收录' },
  { date: '2026-07-22', title: '经典港片修复版上线', desc: '高清修复多部经典作品，画质焕然一新' },
  { date: '2026-07-19', title: '视频加载速度优化完成', desc: 'CDN节点扩充，全国访问延迟降低40%' },
  { date: '2026-07-16', title: '综艺专区内容更新', desc: '新增多档热门综艺节目高清完整版' },
  { date: '2026-07-13', title: '搜索功能智能升级', desc: '支持模糊搜索与智能推荐，找片更方便' },
  { date: '2026-07-10', title: '平台安全防护加固', desc: '全面升级内容安全系统，保障纯净观影环境' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
            最新动态
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            平台更新日志
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            了解91免费视频网站的最新变化与功能升级
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {updates.map((item, idx) => (
            <div key={idx} className="flex gap-4 group">
              <div className="flex flex-col items-center">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-500 shrink-0 mt-1.5 group-hover:scale-125 transition-transform"></div>
                {idx < updates.length - 1 && <div className="w-px flex-1 bg-background-200 mt-1"></div>}
              </div>
              <div className={`pb-6 ${idx === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-xs font-label font-medium text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <h3 className="font-heading font-semibold text-sm text-foreground-900">{item.title}</h3>
                </div>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-6">
          <a
            href="#about"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解平台更多信息
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}